<template>

	<div class="main-contents">
		<div class="mem_container">
			<div class="mem_contents_header myp">
				<div class="title-txt">진행단계별 프로젝트</div>
			</div>
			<div class="mem_info_contents">
				<div class="tec_prj_tab">
					<div class="tab-type5">
						<ul class="tab">
							<li @click="$router.push({name : 'PRJ302M04'})">
								모집중인 프로젝트
							</li>
							<li class="on">
								수행예정 프로젝트
							</li>
							<li @click="$router.push({name : 'PRJ302M01'})">
								수행중인 프로젝트
								<div v-if="projectCountMap.projectIngUnEvalCount > 0" class="alarm show">
									<img src="/images/tab_alarm.png" alt="미평가인재알람"/>
									<p>미평가 IT 프로가 있습니다</p>
								</div>
							</li>
							<li @click="$router.push({name : 'PRJ302M03'})">
								완료 프로젝트
								<div v-if="projectCountMap.projectEndUnEvalCount > 0" class="alarm show">
									<img src="/images/tab_alarm.png" alt="미평가인재알람"/>
									<p>미평가 IT 프로가 있습니다</p>
								</div>
							</li>
						</ul>
					</div>
				</div>

				<div class="contents-body prj_mn">
					<div class="filter">
						<div class="search-box">
							<div style="
								display: inline-flex;
								align-items: center;
								position: relative;
								padding: 2px 15px;
								border: 1px solid #D6D7D8;
								border-radius: 25px;
								background: #fff;
							">
								<InputComp type="text" classNm="search_box int" placeholder="프로젝트명" v-model="input.searchKeyword" @keyup.enter="getList('1')"  ref="ref_search" />
								<div class="search_btn" @click="getList('1')">
									<img class="search" src="/images/icon_srch.png" alt="검색버튼"/>
								</div>
							</div>

							<div class="prj_tit mt-10">
								<strong><span class="prj_cnt">{{pageInfo.totalRecordCount}}개</span></strong>의 프로젝트가 있습니다
							</div>
						</div>

					</div>
					
					<div v-for="(project) in projectList" :key="project.projectSeq" class="prj_mn-box">
						
						<div class="view box-hover">
							<div class="req">
								<div class="top">
									<div class="state_mark ep mr-2-5">수행예정</div>
									<div v-if="project.apprYn == 'N'" class="state_mark rq mr-2-5">미 승 인</div>
									<div class="proc" v-else-if="project.recrEndDateDiff >= 0">모집중</div>
									<div class="new" v-if="project.newYn == 'Y'">N</div>
									
									<div class="right flex">
										<div class="date">등록일자 {{project.regYyyymmdd}}</div>
									</div>
								</div>								
								
								<!--class _new add-->
								<div class="flex sp-tw">
									<div class="itv-outline int_prj_new">									
										<div class="regi pb-0">
											<div class="name prj-tit-hover" @click="clickProjectInfo(project.projectSeq)">{{project.projectNm}}</div>
											<div class="int_box">
												
												<div class="list-view int_prj">
													<div class="label">
														<p>고 객 사</p>
													</div>
													<div class="list">
														<div class="add">{{project.clientNm}}</div>
														<div class="loca"><img src="/images/location.png" alt="위치" />{{project.projectLocCont}}</div>
													</div>
												</div>												
											</div>
										</div>

										<div class="int_box">                                            
											<div class="list-view int_prj">
												<div class="label">
													<p>수 행 사</p>
												</div>
												<div class="list text">{{project.corpNm}}</div>
											</div>
											<div class="list-view int_prj">
												<div class="label">
													<p>개 발 기 간</p>
												</div>
												<div class="list">{{project.projectStartEndYyyymmdd}}</div>
											</div>
											<div class="list-view int_prj">
												<div class="label">
													<p>직 무 분 야</p>
												</div>
												<div class="list">
													<ul class="duty-list">
														<li v-for="(duty, index) in project.dutyList" :key="index">
															<span>
																<SelectComp type="text_comma_split" cdId="PRO141" :value="duty.dutyFilterCd"/>/<SelectComp type="text_comma_split" cdId="PRO142" :value="duty.dutyFieldCd"/>
															</span>
														</li>
													</ul>
												</div>
											</div>
											<div class="list-view int_prj mb-0">
												<div class="label">
													<p>개 발 기 술</p>
												</div>
												<div class="list text">{{project.devTechCont}}</div>
											</div>                                          
										</div>                                        
									</div>

									<!--고객CI/IT프로정보-->
									<div class="client_info">
										<!-- <div class="ci_box">
											<ImageComp type="image" :src="'/api/prj/tec/projectCorpImg?projectSeq='+project.projectSeq" defaultSrc="COMPANY" alt="고객사 로고"/>
										</div> -->
										<div class="deadline flex-col">
											<div>
												<span>
													<img class="member" src="/images/tec/prj/member_sm.png" alt="지원자수"/>
													참여 IT프로 <span class="count">{{project.mberCnt}}</span>명
												</span>
											</div>
											<div>
												<div v-if="project.mberCnt > 0" class="sp_human" @click="clickProjectTecMberList(project)">
													<span>참여 IT프로 보기 &#9654;</span>
												</div>
											</div>											
										</div>
									</div>									
								</div>
							</div>
						</div>

					</div>

					<div v-if="projectList.length == 0" class="prj_mn-box">
						<div class="view box-hover viewbox-none" style="height: 320px;">
							프로젝트가 없습니다.
						</div>
					</div>
				</div>
				
				<!--페이징 컴포넌트 -->
				<PagingComp :pageInfo="pageInfo" @page-click="goPage"/>
				<!--// 페이징 컴포넌트 -->
			</div>
		</div>
	</div>

</template>

<script>

import PagingComp from '@/components/PagingComp.vue';

export default {

	components : {
		PagingComp,
	},

	data() {
		return {
			input: {
				pageIndex : '1',
				
				searchGubun : '1',		// 검색은 프로젝트명으로만
				projectStatus : '2',	// (배열로..) 프로젝트 상태 1:수행중, 2:수행예정, 9:완료
				orderGubun : '1',		// 1:등록일 순, 2:참여인재 많은 순, 3:참여인재 적은 순, 4:개발기간 짧은 순, 5:개발기간 긴 순
				// projectGubun : '',
				prjListInqCond : '2' // 1 : 내가 등록한 부모 프로젝트의 자식 프로젝트, 2 : 내가 등록한 프로젝트 

			}, // 검색조건		

			nowYyyymmdd : '',

			projectList : [],
			projectTecMberList : [],
			pageInfo : {},
			projectCountMap : {},
			unEvalCount : 0,
			projectSeqTecMber : '',
			selectedIndex : [],

			checkBox : false,
		};
	},
	bforeCreate() {
		// console.log('beforeCreate');
	},
	created() {
		// console.log('created');
	},
	beforeMount() {
		// console.log('beforeMount');
		if(this.$route.params) {
			this.input.searchKeyword = this.$route.params.srchName
			if(this.$route.params.corpName) {
				this.input.corpKeyword = this.$route.params.corpName;
			}
		}
	},
	mounted() {
		// console.log('mounted');

		if(this.$route.params != undefined && this.$route.params.pageIndex != undefined) {			
			this.input = this.$route.params;
		}
		this.nowYyyymmdd = new Date().format("yyyyMMdd");
		this.getList();
	},
	beforeUpdate() {
		// console.log('beforeUpdate');
	},
	updated() {
		// console.log('update');
	},
	beforeDestroy() {
		// console.log('beforeDestroy');
	},
	destroyed() {
		// console.log('destroyed');
	},

	methods: {
		getList(div, isScroll = false) {
			if(div) this.input.pageIndex = 1;

			this.$.httpPost('/api/prj/modul/getProjectStatusList', this.input)
				.then(res => {
					//console.log('getMyProjectList RESULT', res.data);

					this.projectList 		= res.data.projectList;
					this.pageInfo 			= res.data.pageInfo;
					this.projectCountMap	= res.data.projectCount;
					this.unEvalCount		= res.data.projectCount.projectIngUnEvalCount + res.data.projectCount.projectEndUnEvalCount;
				
					for(var i in this.projectList){
						
						if(this.projectList[i].dutyFieldCont){
							var tempArr = this.projectList[i].dutyFieldCont.split(',');
							this.projectList[i].dutyList = [];

							for(var j in tempArr){
								this.projectList[i].dutyList.push({dutyFilterCd : tempArr[j].substr(0,2),
																   dutyFieldCd  : tempArr[j]});
							}
						}

					}

					this.projectSeqTecMber = '';

					if(isScroll) {
						window.scroll(0, 0);
					}
				})
				.catch(err => {
					// console.log('============================='); 
					// console.log(err);
					// console.log(err.response);
					// console.log('============================='); 

					alert(err.response.data.error_description);
				});
		},

		goPage(page) {
			// console.log(page);
			this.input.pageIndex = page;
			this.getList('', true);
		},

		orderSearch(orderGubun) {
			this.input.orderGubun = orderGubun;
			this.input.pageIndex = 1;
			this.getList();
		},		

		clickProjectInfo(projectSeq) {			
			this.$router.push({name : 'PRJ303M01', query : {projectSeq : projectSeq}, params : {caller : { name : this.$route.name, params :this.input}}});
		},

		clickProjectTecMberList(project) {
			this.$router.push({name : 'PRJ302M11', params : { project : project, input : this.input ,  caller : {name : this.$route.name, params : this.input} }});
		},

	},
};
</script>
